import sensors from '@xiaoduo/sensors-mark'

sensors.init({
  server_url: 'https://wangcai.1yangai.com/log/event_tracking',
  // heatmap_url 神策分析中点击分析及触达分析功能代码，代码生成工具会自动生成。
  heatmap_url: 'https://static.sensorsdata.cn/sdk/1.14.5/heatmap.min.js',
  heatmap: {
    // 是否开启点击图。default 表示开启，自动采集 $WebClick 事件；'not_collect' 表示关闭
    clickmap: 'default',
    // 是否开启触达注意力图。default 表示开启，自动采集 $WebStay 事件；'not_collect' 表示关闭
    scroll_notice_map: 'default',
    collect_tags: {
      div: true,
    },
  },
  cross_subdomain: false,
  is_track_single_page: true,
  use_client_time: true,
  show_log: false,
  send_type: 'ajax',
  mark: localStorage.getItem('mark'),
})

sensors.registerPage({
  app_id: 'xd031',
})

// 使用参考 xd-csm项目
export function trackSensors() {
  sensors.quick('autoTrack')
}

// 使用参考 xd-csm项目
export function loginSensors(userName) {
  window.gio?.('setUserId', userName) // name用于埋点分析是区分用户
  sensors.login(userName)
}

export function logoutSensors() {
  sensors.logout()
}
